import React, { useState, useEffect, useContext, Fragment } from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import { Button } from 'react-bootstrap';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import parse from 'html-react-parser';
import ErrModalPop from 'components/sales/modal/errorModal';
import {toast} from "react-toastify";
import { ConsolidateReport } from 'components/installation/consolidateReport/consolidateReport';
import { set } from 'date-fns';

const AddIncentive = ({
    getSalesSites,
    incentiveSites,
    getLeadCommertialDetails,
    saveSalesIncentive,
    commertialDetails,
    getSeniorBeneficiary,
    beneficiarySenior,
    history,
    match,
    getEditableData,
    editData,
    getHeadBeneficiary,
    getCalculatedIncentiveAmount,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setIsErrorMsg] = useState('');
  const [siteName, setSiteName] = useState("");
  const [siteId, setSiteId] = useState("");
  const [incentiveFor, setIncentiveFor] = useState("");
  const [incentiveId, setIncentiveId] = useState("");
  const [userName, setUserName] = useState("");
  const [userId, setUserId] = useState("");
  const [seniorName, setSeniorName] = useState("");
  const [seniorId, setSeniorId] = useState("");
  const [amount, setAmount] = useState("");
  const [userIncentive, setUserIncentive] = useState("");
  const [seniorIncentive, setSeniorIncentive] = useState("");
  const [userIncPercentage, setUserIncPercentage] = useState("");
  const [seniorIncPercentage, setSeniorIncPercentage] = useState("");
  const [uIper, setUiper] = useState("");
  const [sIper, setSiper] = useState("");
  const [isErrorModal, setIsErrorModal] = useState(false);
  const [isEditable, setEditable] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [listId, setListId] = useState(0);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [invoiceAmount, setInvoiceAmount] = useState("");
  const [userDropdown,setUserDropdown] = useState([]);
  const [headDropdown, setHeadDropdown] = useState([]);
  const [headId, setHeadId] = useState("");
  const [headName, setHeadName] = useState("");
  const [hIper, setHiper] = useState("");
  const [headIncentive, setHeadIncentive] = useState("");
  const [seniorDropdown, setSeniorDropdown] = useState([]);
  const [userRole, setUserRole] = useState(0);
  const [colSm, setColSm] = useState(6);
  const [headIncPercentage, setHeadIncPercentage] = useState("");
  const [submitShow, setSubmitShow] = useState(false);
 
  const handleModalHide1 = () => setIsErrorModal(false);

  const handleSiteChange = (val) => {
    if(val) {
     setAmount(""); 
     setIncentiveId("");
     setIncentiveFor("");
     setUserId("");
     setUserName("");
     setSeniorId("");
     setSeniorName("");
     setHeadId("");
     setHeadName("");
     setInvoiceNumber("");
     setInvoiceAmount("");
     setSiteName(val.value);
     setSiteId(val.id);
    }
  }

  const handleIncentiveFor = (val) => {
   if((userId == '' && seniorId == '' && headId == '')) {
      var errMsg = 'Please Select beneficiary First!';
      setIsErrorMsg(errMsg);
      setIsErrorModal(true);
      setIsLoading(false);
      return false;
   }
   if(val) { 
      if(val.id) { 
         setIncentiveFor(val.value);
         setIncentiveId(val.id);
         (async () => {
            const data = await getCalculatedIncentiveAmount(siteId,val.id);
            //setAmount(10000);
            if(data) {
              setAmount(data);
            } else {
               setUiper("");
               setSiper("");
               setHiper("");
               setUserIncentive("");
               setSeniorIncentive("");
               setHeadIncentive(""); 
               setAmount("");
               setUserDropdown([]);
               setSeniorDropdown([]);
               setHeadDropdown([]);
               toast.error('No Incentive Amount.');  
            }
         })();
      }
   }
  }

  const handleUser = (val) => {
    if(val) {
      setUserName(val.value);  
      setUserId(val.id);
    }
  }

  const handleSenior = (val) => {
    if(val) {
      setSeniorName(val.value);  
      setSeniorId(val.id);
    }
  }

  const handleHead = (val) => {
   if(val) {
     setHeadName(val.value);  
     setHeadId(val.id);
   }
 }

  useEffect(() => {
    if (userId !== null && userId !== ""){
        setSeniorId("");
        setSeniorName("");
        (async () => {
            const data = await getSeniorBeneficiary(userId);
            //console.log(data);return false;
            if(data.user_key) {
               if(data.user_key == 6) { 
                 setSeniorDropdown(data.result);
               }
               if(data.user_key == 5) {
                  setHeadDropdown(data.result);
               }
            }
          })();
    }
  },[userId]);

  useEffect(() => {
   if (seniorId !== null && seniorId !== ""){
       setHeadId("");
       setHeadName("");
       (async () => {
           const data = await getHeadBeneficiary(seniorId);
           if(data.length > 0) {
            setHeadDropdown(data); 
           }
         })();
   }
 },[seniorId]);

  useEffect(() => {
    if((incentiveFor === 'Rental/Capex' || incentiveFor === 'Installation' || 
    incentiveFor === 'Tag' || incentiveFor === 'Cartage') && amount != '' && userId != '' && seniorId != '' && headId != '') {
       var amountInt = parseInt(amount);
       var userIns = amountInt * 70 / 100;
       var seniorIns = amountInt * 20 / 100;
       var headIns = amountInt * 10 / 100;
       setUiper('(70%)');
       setSiper('(20%)');
       setHiper('(10%)');
       setUserIncPercentage(70);
       setSeniorIncPercentage(20);
       setHeadIncPercentage(10);
       setUserIncentive(userIns);
       setSeniorIncentive(seniorIns);
       setHeadIncentive(headIns);
     } else if((incentiveFor === 'Rental/Capex' || incentiveFor === 'Installation' || 
     incentiveFor === 'Tag' || incentiveFor === 'Cartage') && amount != '' && userId == '') {
        var amountInt = parseInt(amount);
        var seniorIns = amountInt * 75 / 100;
        var headIns = amountInt * 25 / 100;
        setSiper('(75%)');
        setHiper('(25%)');
        setSeniorIncPercentage(75);
        setHeadIncPercentage(25);
        setSeniorIncentive(seniorIns);
        setHeadIncentive(headIns);
     } else if((incentiveFor === 'Rental/Capex' || incentiveFor === 'Installation' || 
     incentiveFor === 'Tag' || incentiveFor === 'Cartage') && amount != '' && userId != '' && seniorId == '' && headId != '') {
        var amountInt = parseInt(amount);
        var userIns = amountInt * 75 / 100;
        var headIns = amountInt * 25 / 100;
        setUiper('(75%)');
        setHiper('(25%)');
        setUserIncPercentage(75);
        setHeadIncPercentage(25);
        setUserIncentive(userIns);
        setHeadIncentive(headIns);
     } else if((incentiveFor === 'Rental/Capex' || incentiveFor === 'Installation' || 
     incentiveFor === 'Tag' || incentiveFor === 'Cartage') && amount != '' && userId != '' && seniorId != '' && headId == '') {
        var amountInt = parseInt(amount);
        var userIns = amountInt * 75 / 100;
        var seniorIns = amountInt * 25 / 100;
        setUiper('(75%)');
        setSiper('(25%)');
        setUserIncPercentage(75);
        setSeniorIncPercentage(25);
        setUserIncentive(userIns);
        setSeniorIncentive(seniorIns);
     } else {
        var userIns = 0;
        var seniorIns = 0;
        var headIns = 0;
        setUiper("");
        setSiper("");
        setHiper("");
        setUserIncPercentage("");
        setSeniorIncPercentage("");
        setHeadIncPercentage("");
        setUserIncentive(userIns);
        setSeniorIncentive(seniorIns);
        setHeadIncentive(headIns);
     }
  },[amount,incentiveFor]);

  useEffect(() => {
    if (getSalesSites !== null){
        (async () => {
            setIsLoading(true);
            await getSalesSites();
            setIsLoading(false);
          })();
    }
  },[getSalesSites]);

  useEffect(() => {
    if(siteId !== "" && siteId !== null) { 
        (async () => {
            const data = await getLeadCommertialDetails(siteId); console.log(data);
            if(data?.userArray.length > 0 && data?.userRole === 7) {
                setUserDropdown(data.userArray);
                setUserRole(data?.userRole);
                setColSm(6);
            } else if(data?.userArray.length > 0 && data?.userRole === 6) {
                setSeniorDropdown(data.userArray);
                setUserRole(data?.userRole);
                setColSm(6);
            } else {
               setUiper("");
               setSiper("");
               setHiper("");
               setUserId("");
               setUserName("");
               setSeniorId("");
               setSeniorName("");
               setHeadId("");
               setHeadName("");
               setUserIncentive("");
               setSeniorIncentive("");
               setHeadIncentive(""); 
               setAmount("");
               setUserDropdown([]);
               setSeniorDropdown([]);
               setHeadDropdown([]);
               setUserRole(0);
               setColSm(6);
               toast.error('No valid user found for incentive.');
            }
          })();
     }
  },[siteId]);

  const handleSubmit = async () => {
    var totalAmount = parseInt(userIncentive) + parseInt(seniorIncentive);
    if(siteId == "" || incentiveId == "" || amount == "" || (userId == '' && seniorId == '' && headId == '')) {
        var errMsg = 'Please Select Mandatory Fields!';
        setIsErrorMsg(errMsg);
        setIsErrorModal(true);
        setIsLoading(false);
        return false;
    } if(parseInt(amount) < totalAmount) {
        var errMsg = 'The incentive amount cannot exceed the amount.';
        setIsErrorMsg(errMsg);
        setIsErrorModal(true);
        setIsLoading(false);
        return false;
    }
  
    const data = {
        'site_id': siteId,
        'incentive_for': incentiveId, 
        'user_id': userId,
        'senior_id': seniorId,
        'head_id': headId,
        'amount': amount,
        'user_incentive': userIncentive,
        'senior_incentive': seniorIncentive,
        'user_inc_percentage': userIncPercentage,
        'senior_inc_percentage': seniorIncPercentage,
        'head_incentive': headIncentive,
        'head_inc_percentage': headIncPercentage,
        'update': isUpdate,
        'id': listId,
        'invoice_no': invoiceNumber,
        'invoice_amount': invoiceAmount
    };
    //console.log(data); return false;
    (async () => {
       const res =  await saveSalesIncentive(data);
       if(res === true) {
        toast.success('Incentive save successfully.');             
        setTimeout(history.push(`${baseUrl}/site_incentive`),1000);
       }
    })();
  }

  useEffect (() => {
    if(match.params.id !== undefined && match.params.site_id !== undefined){
        setEditable(true);
        (async() => {
           const res = await getEditableData(match.params.id,match.params.site_id);
           if(res?.response?.data) {
              const data = res?.response?.data;
              const site = data?.site_name +' ('+ data?.site_no +')';
              setSiteId(data?.site_id);
              setSiteName(site);
              setAmount(data?.incentive_amount);
              setInvoiceNumber(data?.invoice_number);
              setInvoiceAmount(data?.invoice_amount);
              if(data?.user_id && data?.user_id !== null) {
               setUserId(data?.user_id);
               setUserName(data?.user_name);
               setUserIncPercentage(data?.user_incentive_percentage);
              }
              if(data?.senior_id && data?.senior_id !== null) {
               setSeniorId(data?.senior_id);
               setSeniorName(data?.senior_name);
               setSeniorIncPercentage(data?.senior_incentive_percentage);
              }
              if(data?.head_id && data?.head_id !== null) {
               setHeadId(data?.head_id);
               setHeadName(data?.head_name);
               setHeadIncPercentage(data?.senior_incentive_percentage);
              }
              setIsUpdate(true);
              setListId(data?.id);
              setIncentiveId(data?.incentive_for);
              setIncentiveFor(data?.incentive_for);
              if(data?.sales_status == 1 || data?.sales_status == 2) {
               setSubmitShow(true);
              }
           }
        })()    
    }
    (async() => {
        await getLeadCommertialDetails(0)
    })()
  },[]);

  useEffect(() => {
    (async () => {
        if(match.params.site_id !== undefined){
            await getLeadCommertialDetails(match.params.site_id);
        }  
      })();
  },[isEditable]) 

  return (
    <Layout
      title={localization.addIncentive}
      isGoback
      isLoading={isLoading}
      linkFlag
      linkUrl={`${baseUrl}/site_incentive`}
    >
    <div className="container-fluid">
     <div className="card">
      <div className="card-body">
       <div className="row">
        {commertialDetails?.siteDetail && commertialDetails?.siteDetail.length > 0 &&
         <div style={{'marginBottom':'20px'}} className="container-fluid col-md-12 col-sm-12">
          <table className="table table-bordered kmb dashboard-table">
            <thead>
                <tr>
                   <th>Site Name</th> 
                   <th>Site Number</th>
                   <th>Cartage Amount</th>
                   <th>Commertial Type</th>
                   <th>Onboarding Date</th>
                   <th>Created By</th>
                </tr>
            </thead>
            <tbody>
               {commertialDetails?.siteDetail?.map((item,x) =>
                <tr key={x}>
                   <td>{item.client_name}</td>
                   <td>{item.site_no}</td>
                   <td>{item.cartage_amount?item.cartage_amount:0}</td>
                   <td>{item.name}</td> 
                   <td>{item.onboarding_date}</td>
                   <td>{item.created_by}</td>
                </tr>
              )}
            </tbody>
          </table>
         </div>
        }
        {commertialDetails?.tagsData && commertialDetails?.tagsData.length > 0 && 
         <div style={{'marginBottom':'20px'}} className="container-fluid col-md-12 col-sm-12">
          <table className="table table-bordered kmb dashboard-table">
            <thead>
                <tr>
                   <th>Tag</th> 
                   <th>Type</th>
                   <th>Quantity</th>
                   <th>Receive Quantity</th>
                   <th>Price</th>
                   <th>Base Price</th>
                   <th>Total</th>
                </tr>
            </thead>
            <tbody>
               {commertialDetails?.tagsData?.map((item,x) =>
                <tr key={x}>
                   <td width={'15%'}>{item.tag_name}</td>
                   <td>{item.type}</td>
                   <td>{item.qty}</td>
                   <td width={'20%'}>{item.receive_qty}</td>
                   <td>{item.price?item.price:0}</td>
                   <td>{item.master_base_price?item.master_base_price:0}</td>
                   <td>{item.type === 'Free' ? 0:item.total}</td>
                </tr>
              )}
            </tbody>
          </table>
         </div>
        }
        {commertialDetails?.gatesData && commertialDetails?.gatesData.length > 0 &&
         <div style={{'marginBottom':'20px'}} className="container-fluid col-md-12 col-sm-12">
          <table className="table table-bordered kmb dashboard-table">
            <thead>
                <tr>
                   <th>Gate</th>
                   <th>Type</th> 
                   <th>Base Price</th>
                </tr>
            </thead>
            <tbody>
               {commertialDetails?.gatesData?.map((item,x) =>
                <tr key={x}>
                   <td width={'33%'}>{item.name}</td>
                   <td>{item.type_lead}</td>
                   {item.type_lead == 'Capex' &&
                   <td>{item.capex_base_price?item.capex_base_price:0}</td>
                   }
                   {item.type_lead == 'Rental' &&
                     <td>{item.rental_base_price?item.rental_base_price:0}</td>
                   }
                </tr>
              )}
            </tbody>
          </table>
         </div>
        }
         <div className="col-sm-4">
         <DropDownInput
            data={incentiveSites?.sites}
            label={'Site'}
            required={true}
            isStarRequired={true}
            errorMsg={localization.isRequired}
            getIdValue={(val) => handleSiteChange(val)} 
            value={siteName}               
         />
         </div>
         {/* {(userRole === 0 || userRole === 7) && */}
         <div className="col-sm-4">
         <DropDownInput
            data={userDropdown}
            label={'User'}
            required={true}
            isStarRequired={true}
            errorMsg={localization.isRequired}
            getIdValue={(val) => handleUser(val)}   
            value={userName}             
         />
         </div>
         {/* } */}
         <div className="col-sm-4">
         <DropDownInput
            data={seniorDropdown}
            label={'Senior'}
            required={true}
            isStarRequired={true}
            errorMsg={localization.isRequired}
            getIdValue={(val) => handleSenior(val)} 
            value={seniorName}               
         />
         </div> 
         <div className="col-sm-4">
         <DropDownInput
            data={headDropdown}
            label={'Head'}
            required={true}
            isStarRequired={true}
            errorMsg={localization.isRequired}
            getIdValue={(val) => handleHead(val)}   
            value={headName}             
         />
         </div>
         <div className="col-sm-4">
         <DropDownInput
            data={[
                {name: 'Rental/Capex', id: 'Rental/Capex'},
                {name: 'Installation', id: 'Installation'},
                {name: 'Cartage', id: 'Cartage'},
                {name: 'Tag', id: 'Tag'}
            ]}
            label={localization.incentiveFor}
            required={true}
            isStarRequired={true}
            errorMsg={localization.isRequired}
            getIdValue={(val) => handleIncentiveFor(val)} 
            value={incentiveFor}               
         />
         </div>
         <div className="col-sm-4">
         <ConstantInput
            label={'Total Incentive Amount'}
            type="text"
            required
            isStarRequired={true}
            handleChange={(value) => {
               setAmount(value);
            }}
            value={amount}
         />
         </div>
         {/* {(userRole === 0 || userRole === 7) && */}
         <div className="col-sm-4">
         <ConstantInput
            label={'User Incentive'+(uIper)}
            type="text"
            required
            isStarRequired={true}
            handleChange={(value) => {
                setUserIncentive(value);
            }}
            value={userIncentive}
         />
         </div>
         {/* } */}
         <div className="col-sm-4">
         <ConstantInput
            label={'Senior Incentive'+ (sIper)}
            type="text"
            required
            isStarRequired={true}
            handleChange={(value) => {
                setSeniorIncentive(value);
            }}
            value={seniorIncentive}
         />
         </div>
         <div className="col-sm-4">
         <ConstantInput
            label={'Head Incentive'+ (hIper)}
            type="text"
            required
            isStarRequired={true}
            handleChange={(value) => {
                setSeniorIncentive(value);
            }}
            value={headIncentive}
         />
         </div>
         <div className={'col-sm-6'}>
         <ConstantInput
            label={'Invoice No.'}
            type="text"
            required
            //isStarRequired={true}
            handleChange={(value) => {
                setInvoiceNumber(value);
            }}
            value={invoiceNumber}
         />
         </div>
         <div className={'col-sm-6'}>
         <ConstantInput
            label={'Invoice Amount'}
            type="text"
            required
            //isStarRequired={true}
            handleChange={(value) => {
                setInvoiceAmount(value);
            }}
            value={invoiceAmount}
         />
         </div>
         {submitShow == false &&
         <div className="col-md-12 col-sm-5">
         <button className="btn btn-sm btn-primary" onClick={handleSubmit}>Submit
         </button>
         </div>
         }
       </div>
      </div>
     </div>
    </div>
    <ErrModalPop
        title={localization.error}
        show={isErrorModal}
        handleModalHide={handleModalHide1}
        keyboard
        backdrop
      >
        <div className="text-center">
          {parse(errorMsg)}
        </div>
    </ErrModalPop>

    </Layout>
  );
};

export default AddIncentive;
